import { FormattedProduct } from 'types/AlgoliaResults';
import { SearchResultCard, getCMSImages } from '..';
import { PathTranslations } from 'service/localization/getPathTranslations';

export const mapAlogliaProductToSearchCard = (
  product: FormattedProduct,
  labels: Record<string, string>,
  pathTranslations: PathTranslations,
): SearchResultCard => ({
  resultType: 'product',
  id: product.objectID,
  title: product.title,
  description: product.description,
  category: product.categories.length ? product.categories[0].name : '',
  images: getCMSImages(product.images),
  link: {
    url: `${pathTranslations.product}${product.slug}`,
    displayName: labels.see_details || 'See details',
  },
});
